"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function ReadyToDeploy() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="ready-to-deploy" className="dark bg-background text-foreground relative min-h-[80vh] flex items-center justify-center py-24 px-4 overflow-hidden">
      {}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-primary/10 rounded-full blur-[120px] pointer-events-none" />
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[400px] h-[400px] bg-secondary/5 rounded-full blur-[80px] pointer-events-none" />

      {}
      <div className="absolute inset-0 bg-[linear-gradient(to_right,#80808012_1px,transparent_1px),linear-gradient(to_bottom,#80808012_1px,transparent_1px)] bg-[size:40px_40px] pointer-events-none opacity-20" />

      {}
      <div ref={ref} className={`relative z-10 w-full max-w-5xl mx-auto bg-card/80 backdrop-blur-xl border-4 border-primary rounded-3xl p-10 md:p-20 text-center shadow-[0_0_80px_rgba(60,197,243,0.15)] transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0 scale-100" : "opacity-0 translate-y-12 scale-95"}`}>
        <h2 className="text-5xl md:text-7xl lg:text-8xl font-black tracking-tighter mb-12 uppercase text-foreground drop-shadow-[0_0_15px_rgba(255,255,255,0.2)]">start search now</h2>

        <div className="relative inline-flex items-center justify-center mt-4">
          {}
          <div className="absolute inset-0 rounded-full bg-secondary/30 animate-[ping_3s_cubic-bezier(0,0,0.2,1)_infinite] pointer-events-none" />
          <div className="absolute inset-0 rounded-full border-2 border-secondary/60 animate-[ping_3s_cubic-bezier(0,0,0.2,1)_infinite] pointer-events-none" style={{
          animationDelay: '1.5s'
        }} />
          
          {}
          <Button asChild size="lg" className="relative z-10 bg-secondary text-secondary-foreground hover:bg-secondary/90 text-xl md:text-2xl px-12 py-8 md:px-16 md:py-10 rounded-xl font-bold uppercase tracking-widest transition-transform hover:scale-105 shadow-[0_0_30px_rgba(252,178,49,0.4)] hover:shadow-[0_0_50px_rgba(252,178,49,0.6)]">
            <Link to="/PocketPalPage" className="inline-flex items-center justify-center gap-2 whitespace-nowrap [&_svg]:pointer-events-none [&_svg:not([class*='size-'])]:size-4 shrink-0 [&_svg]:shrink-0 outline-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 aria-invalid:border-destructive h-10 has-[>svg]:px-4 relative z-10 bg-secondary text-xl px-12 py-8 rounded-xl font-bold uppercase tracking-widest transition-transform shadow-[0_0_30px_rgba(252,178,49,0.4)] !text-[hsl(214,57%,21%)] disabled:pointer-events-none disabled:opacity-50 dark:aria-invalid:ring-destructive/40 hover:bg-secondary/90 md:text-2xl md:px-16 md:py-10 hover:scale-105 hover:shadow-[0_0_50px_rgba(252,178,49,0.6)]">TALK TO POCKETPAL</Link>
          </Button>
        </div>
      </div>
    </section>;
}